import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import { MaskedField } from "../../components/fields/MaskedField";
import { tipoRefeicaoApi } from "../../services/Api";
import { ListApi, FormApi, List, CrudForm } from "elentari";

export function TiposRefeicoesList(props) {
  const listOptions = {
    defaultOrder: "horario",
    fields: {
      nome: {
        label: "Refeição",
      },
      horario: {
        label: "Horário Padrão",
      },
    },
  };

  return (
    <ListApi api={tipoRefeicaoApi}>
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          labelNew="Novo"
          deleteItem={handleDelete}
          onClickEdit={(item) =>
            props.history.push(`/tipos-de-refeicoes/${item.id}`)
          }
          onClickNew={() => props.history.push("/tipos-de-refeicoes/new")}
          getPage={getPage}
          getCount={getCount}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function TiposRefeicoesForm(props) {
  const isValidTime = (horario) =>
    /(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]/.test(horario);

  const validate = (values) => ({
    nome: values.nome ? undefined : "Obrigatório",
    horario: values.horario
      ? isValidTime(values.horario)
        ? undefined
        : "Horário Inválido"
      : "Obrigatório",
  });

  return (
    <FormApi api={tipoRefeicaoApi} {...props}>
      {({ handleSubmit, getItem }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container direction="column" spacing={16}>
            <Grid item>
              <Grid container spacing={16}>
                <Grid item sm>
                  <Field
                    fullWidth
                    autoFocus
                    component={TextField}
                    label="Tipo da Refeição"
                    name="nome"
                  />
                </Grid>
                <Grid item sm>
                  <Field
                    mask={[/\d/, /\d/, ":", /\d/, /\d/]}
                    label="Horário"
                    component={MaskedField}
                    name="horario"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}
